import { Component, Inject } from '@angular/core';
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { CuttingClient, UserHelper } from 'cloud-shared-lib';
import { tap } from 'rxjs';

interface DeleteAccountDialogData {
  client: CuttingClient;
}

@Component({
  selector: 'cutting-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
})
export class DeleteAccountDialogComponent {
  userNameControl = new FormControl('', [Validators.required, this.fullNameValidator.bind(this)]);

  constructor(
    protected dialogRef: MatDialogRef<DeleteAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected dialogData: DeleteAccountDialogData
  ) {
    this.userNameControl.valueChanges
      .pipe(
        tap(() => {
          if (!this.userNameControl.touched) {
            this.userNameControl.markAsTouched();
          }
        })
      )
      .subscribe();
  }

  get userName(): string {
    return UserHelper.getFullName(
      this.dialogData.client.surname,
      this.dialogData.client.name,
      this.dialogData.client.patronymic
    );
  }

  private fullNameValidator(control: FormControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const expectedName = this.userName;
    if (control.value.trim() !== expectedName.trim()) {
      return { fullNameMismatch: { expected: expectedName, actual: control.value } };
    }

    return null;
  }
}
